import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.links}>
            <Link to="/privacy-policy" className={styles.link}>
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className={styles.link}>
              Terms of Service
            </Link>
            <Link to="/contact-us" className={styles.link}>
              Contact Us
            </Link>
            <Link to="/faq" className={styles.link}>
              FAQ
            </Link>
            <Link to="/trust" className={styles.link}>
              Trust
            </Link>
            <Link to="/pkm" className={styles.link}>
              PKM Overview
            </Link>
            <a
              href="https://x.com/mypeopledb"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              title="Follow us on X"
            >
              <svg className={styles.twitterIcon} viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
              Follow on X
            </a>
          </div>
          <div className={styles.copyright}>
            © {new Date().getFullYear()}{' '}
            <Link to="https://www.objectnirvana.com" className={styles.companyLink}>
              Object Nirvana, Inc.
            </Link>{' '}
            All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
